/* RESPONSIBLE TEAM: team-reporting */

import { Chart } from '@highcharts/react';
import Highcharts from 'highcharts/esm/highcharts.src.js';
import 'highcharts/esm/modules/heatmap.src.js';

import '@/features/reporting-charts/highcharts-theme';
import { buildHeatmapOptions } from '@/features/reporting-charts/transforms/heatmap';
import type {
  ChartConfig,
  ChartDataResponse,
  RenderContext,
} from '@/features/reporting-charts/types';

interface HeatmapChartProps {
  data: ChartDataResponse;
  config: ChartConfig;
  renderContext: RenderContext;
  className?: string;
}

export function HeatmapChart({ data, config, renderContext, className }: HeatmapChartProps) {
  const options = buildHeatmapOptions(data, config, renderContext);

  return <Chart highcharts={Highcharts} containerProps={{ className }} options={options} />;
}
